import { ReactComponent as Center } from 'images/newIcons/center.svg';
import { ReactComponent as Cursor } from 'images/newIcons/cursor.svg';
import { ReactComponent as Group } from 'images/newIcons/group.svg';
import { ReactComponent as Logistic } from 'images/newIcons/logistic.svg';
import { ReactComponent as Mountain } from 'images/newIcons/mountain.svg';
import { ReactComponent as Name } from 'images/newIcons/name.svg';
import { ReactComponent as ObjectID } from 'images/newIcons/objectID.svg';
import { ReactComponent as Object } from 'images/newIcons/objectPassive.svg';
import { ReactComponent as Railway } from 'images/newIcons/railway.svg';
import { ReactComponent as Train } from 'images/newIcons/train.svg';
import googleSatelliteLayer from 'images/raster/google-satellite-layer.png';
import imagery from 'images/raster/imagery.png';
import mapboxMinimalLayer from 'images/raster/mapbox-minimal-layer.png';
import mapboxSatelliteLayer from 'images/raster/mapbox-satellite-layer.png';
import mapboxStreetLayer from 'images/raster/mapbox-street-layer.png';
import satellite from 'images/raster/satellite.png';
import sovietMilitaryLayer from 'images/raster/soviet-military-layer.png';
import sovietMilitary from 'images/raster/sovietMilitary.png';

export enum MAP_LAYERS_NAMES {
  googleSatellite = 'googleSatellite',
  mapboxMinimalism = 'mapboxMinimalism',
  streetMap = 'streetMap',
  mapboxSatellite = 'mapboxSatellite',
  infrastructure = 'infrastructure',
  elevation = 'elevation',
  fire = 'fire',
  demMap = 'demMap',
  openTopoMap = 'openTopoMap',
  railroads = 'railroads',
  railStations = 'railStations',
  gcFrontline = 'gcFrontline',
  gcPlacemarks = 'gcPlacemarks',
  googleSatelliteUpper = 'googleSatelliteUpper',
  mapboxSatelliteUpper = 'mapboxSatelliteUpper',
  sovietMilitaryMap = 'sovietMilitaryMap',
  sovietMilitaryMapUpper = 'sovietMilitaryMapUpper',
}

export const MAP_BACKING_LAYERS = [
  {
    label: 'Satellite',
    name: MAP_LAYERS_NAMES.googleSatellite,
    preview: googleSatelliteLayer,
  },
  {
    label: 'Карта улиц',
    name: MAP_LAYERS_NAMES.streetMap,
    preview: mapboxStreetLayer,
  },
  {
    label: 'Mapbox',
    name: MAP_LAYERS_NAMES.mapboxSatellite,
    preview: mapboxSatelliteLayer,
  },
  {
    label: 'Минимализм',
    description: 'Минимальная чёрно-белая карта',
    name: MAP_LAYERS_NAMES.mapboxMinimalism,
    preview: mapboxMinimalLayer,
  },
  {
    label: 'Карта ГШ',
    name: MAP_LAYERS_NAMES.sovietMilitaryMap,
    preview: sovietMilitaryLayer,
  },
];

export const MAP_SETTINGS_OPTIONS = [
  {
    value: 'showAim',
    label: 'Центр карты',
    icon: <Center />,
  },
  {
    value: 'showCustomCursors',
    label: 'Пользовательский курсор',
    icon: <Cursor />,
  },
  { value: 'showLabels', label: 'Названия на карте', icon: <Name /> },
  { value: 'showObjects', label: 'Объекты на карте', icon: <Object /> },
  { value: 'clusterObjects', label: 'Сгруппировать объекты', icon: <Group /> },
  {
    value: 'showObjectIDs',
    label: 'Показывать ID объектов',
    icon: <ObjectID />,
  },
];

export const mapUpperLayers = {
  height: [
    {
      label: 'Карта высот',
      description: 'Уровень моря, высота деревьев',
      name: MAP_LAYERS_NAMES.elevation,
      icon: <Mountain />,
    },
    {
      label: 'Карта высот v2.0',
      description: 'Self-hosted данные по высотам',
      name: MAP_LAYERS_NAMES.demMap,
      icon: <Mountain />,
    },
    {
      label: 'OpenTopoMap',
      description: 'Альтернативная карта высот',
      name: MAP_LAYERS_NAMES.openTopoMap,
      icon: <Mountain />,
    },
    {
      label: 'Высоты карты ГШ',
      description: 'Soviet Military Map',
      name: MAP_LAYERS_NAMES.sovietMilitaryMapUpper,
      preview: sovietMilitary,
    },
  ],
  imagery: [
    {
      label: 'Google Satellite',
      description: 'Спутниковый слой Google',
      name: MAP_LAYERS_NAMES.googleSatelliteUpper,
      preview: satellite,
    },
    {
      label: 'Спутниковые снимки',
      description: 'Спутниковые снимки MapBox',
      name: MAP_LAYERS_NAMES.mapboxSatelliteUpper,
      preview: imagery,
    },
  ],
};

export const geoconfirmedLayers = [
  {
    label: 'Линия боевого соприкосновения',
    name: MAP_LAYERS_NAMES.gcFrontline,
  },
  {
    label: 'Пожары',
    name: MAP_LAYERS_NAMES.fire,
  },
  {
    label: 'Геолоцированные события',
    name: MAP_LAYERS_NAMES.gcPlacemarks,
  },
];

export const logisticLayers = [
  {
    title: 'Слой инфраструктуры',
    description: 'Заводы, производства, энергия',
    icon: <Logistic />,
    name: MAP_LAYERS_NAMES.infrastructure,
  },
  {
    title: 'Карта ЖД',
    description: 'Выгрузка ЖД с OSM',
    icon: <Railway />,
    name: MAP_LAYERS_NAMES.railroads,
  },
  {
    title: 'ЖД станции',
    description: 'Карта ЖД станций',
    icon: <Train />,
    name: MAP_LAYERS_NAMES.railStations,
  },
];
